function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { createContext, useMemo } from 'react';
import { AdRoot } from '@domain-group/fe-co-adspot';
import { ToggledFeatureKey } from '@domain-group/fe-allhomes-library';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { useAdbridg } from './use-adbridg';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var AdContext = /*#__PURE__*/createContext({
  disableAds: false
});
export var AdProvider = _ref => {
  var _ref$disableAds = _ref.disableAds,
    disableAdsProp = _ref$disableAds === void 0 ? false : _ref$disableAds,
    targeting = _ref.targeting,
    children = _ref.children;
  var _useAllhomesApi = useAllhomesApi(),
    toggledFeatures = _useAllhomesApi.toggledFeatures,
    disableAds = _useAllhomesApi.disableAds;
  useAdbridg(_objectSpread({
    disabled: disableAds || !toggledFeatures.ADBRIDG
  }, targeting));
  var contextValue = useMemo(() => ({
    disableAds: disableAds || disableAdsProp
  }), [disableAds, disableAdsProp]);
  return ___EmotionJSX(AdContext.Provider, {
    value: contextValue
  }, toggledFeatures[ToggledFeatureKey.ADBRIDG] ? children : ___EmotionJSX(AdRoot, {
    noAds: disableAds
  }, children));
};